import React, { useState } from 'react';
import IsLoadingBar from '../isLoading';
import { toast } from 'react-toastify';
import Auth from '../../Auth/Auth';
import { removeBoldTags } from '../../Helpers/SearchHelpers';
import unknownSvg from '../../images/unknown.svg';
import downloadSvg from '../../images/download.svg';

const auth = new Auth();
const getImageSrcByExtension = (fileExtension) => {
    try {
        const imageSrc = require(`../../images/${fileExtension}.svg`);
        return imageSrc.default;
    } catch (error) {
        return unknownSvg;
    }
};

const getImageSrc = (fileExtension) => {
    let imageSrc;
    fileExtension = fileExtension.toLowerCase();

    if (fileExtension === 'jpg' || fileExtension === 'jpeg' || fileExtension === 'png' || fileExtension === 'gif') {
        imageSrc = getImageSrcByExtension('img');
    } else if (fileExtension === 'ready' || fileExtension === 'error' || fileExtension === 'done') {
        imageSrc = getImageSrcByExtension('ftp');
    }
    else {
        imageSrc = getImageSrcByExtension(fileExtension);
    }
    return imageSrc;
};

function JiraAttachments({ jiraAttachments }) {
    const [isDownloading, setIsDownloading] = useState(false);
    const attachmentTypes = {};
    let allAttachments = jiraAttachments.split(',');
    allAttachments
        .forEach((attachment, index) => {
            const delimiter = ':';
            if (!attachment.includes(delimiter)) {
                return;
            }
            let [attachmentTitle, ...attachmentSrc] = attachment.split(':');
            attachmentSrc = attachmentSrc.join(':');
            attachmentTitle = removeBoldTags(attachmentTitle);

            if (!attachmentTitle.includes('.')) {
                return;
            }

            const extension = attachmentTitle.split('.').pop().trim();
            attachmentTypes[extension] = attachmentTypes[extension] || [];

            const attachmentPreview = (
                <div className='attachment-preview' key={index}>
                    <img
                        title={attachmentTitle}
                        src={getImageSrc(extension)}
                        alt={attachmentTitle}
                    ></img>
                    <div className='dark-overlay'>
                        {isDownloading && <IsLoadingBar />}
                        <button className='download-icon' onClick={() => downloadJiraAttachment(attachmentSrc, attachmentTitle)}
                        >
                            <img src={downloadSvg} alt='download' />
                        </button>
                        <div className='attachmentTitle'>{attachmentTitle}</div>
                    </div>
                </div>);

            attachmentTypes[extension].push(attachmentPreview);
        });

    const downloadJiraAttachment = async (url, attachmentTitle) => {
        setIsDownloading(true);
        let accessToken = await auth.getToken();
        try {
            const response = await fetch('/api/downloadJiraAttachment', {
                method: 'GET',
                headers: {
                    'Authorization': 'Bearer ' + accessToken,
                    contenturl: url,
                    withCredentials: true,
                    crossDomain: true
                }
            });

            if (!response.ok) {
                throw new Error(response.statusText);
            }

            const contentDisposition = response.headers.get('Content-Disposition');
            const filenameMatch = contentDisposition.match(/filename="(.+)"/);
            const filename = filenameMatch ? filenameMatch[1] : 'JiraAttachment.txt';

            // Save the file data in state
            const attachmentData = await response.arrayBuffer();
            const blob = new Blob([attachmentData], { type: 'application/octet-stream' });

            // Create a link element and trigger a download
            const link = document.createElement('a');
            link.href = URL.createObjectURL(blob);
            link.download = filename;
            document.body.appendChild(link);
            link.click();

            // Cleanup
            document.body.removeChild(link);

        } catch (error) {
            const errorMsg = `Error downloading file: ${attachmentTitle}. ${error}`;
            toast(errorMsg, {
                position: 'top-right',
                hideProgressBar: true,
                closeOnClick: true,
            });
        } finally {
            setIsDownloading(false);
        }
    };

    const sortedAttachments = Object.keys(attachmentTypes)
        .sort()
        .flatMap((key) => attachmentTypes[key]);

    return (
        <div className='attachment-container'>

            <p>
                <strong>Attachments ({allAttachments.length}) :</strong>
                <br />
            </p>
            {sortedAttachments}

        </div>
    );
}

export default JiraAttachments;